import { Link } from 'shared/types';
import createTemplate from '../template/createTemplate';

export default (link: Link, lang: string) =>
  createTemplate(link.href)({ lang });
